import { useState, useRef } from 'react';
import { MissingReferences } from '../../components/ScriptGeneration/common';

export interface Step1Progress {
  field?: string;
  content?: string;
  title?: string;
  welcomeMessage?: string;
  summary?: string;
  isComplete?: boolean;
}

export interface ShotsGeneratingProgress {
  current: number;
  total: number;
  isGenerating: boolean;
}

export function useScriptPageState() {
  const [isEditing, setIsEditing] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isFailed, setIsFailed] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  // Step 1 流式生成状态
  const [isStep1Generating, setIsStep1Generating] = useState(false);
  const [step1Progress, setStep1Progress] = useState<Step1Progress>({});

  // 自动启动防抖标记
  const startGenerationCalledRef = useRef(false);
  const startGenerationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // 分镜弹窗状态
  const [showStoryboardModal, setShowStoryboardModal] = useState(false);
  const [isRegenerateMode, setIsRegenerateMode] = useState(false);

  // 缺失引用弹窗状态
  const [showMissingRefsModal, setShowMissingRefsModal] = useState(false);
  const [missingRefs, setMissingRefs] = useState<MissingReferences>({ characters: [], props: [], scenes: [], voiceRoles: [] });
  const [pendingRegenerateMode, setPendingRegenerateMode] = useState(false);

  // 分镜生成进度
  const [shotsGeneratingProgress, setShotsGeneratingProgress] = useState<ShotsGeneratingProgress>({ current: 0, total: 0, isGenerating: false });
  const [newShotIndices, setNewShotIndices] = useState<number[]>([]);

  const resetError = () => {
    setIsFailed(false);
    setErrorMessage(undefined);
  };

  return {
    isEditing, setIsEditing,
    isGenerating, setIsGenerating,
    isProcessing, setIsProcessing,
    isFailed, setIsFailed,
    errorMessage, setErrorMessage,
    isStep1Generating, setIsStep1Generating,
    step1Progress, setStep1Progress,
    startGenerationCalledRef, startGenerationTimeoutRef,
    showStoryboardModal, setShowStoryboardModal,
    isRegenerateMode, setIsRegenerateMode,
    showMissingRefsModal, setShowMissingRefsModal,
    missingRefs, setMissingRefs,
    pendingRegenerateMode, setPendingRegenerateMode,
    shotsGeneratingProgress, setShotsGeneratingProgress,
    newShotIndices, setNewShotIndices,
    resetError,
  };
}
